import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "overlay" }
const _hoisted_2 = { class: "d-flex flex-column mt-4" }
const _hoisted_3 = { class: "d-flex flex-row mt-3 toggle-click-parent" }
const _hoisted_4 = { class: "toggle-dropdown toggle-click-child" }
const _hoisted_5 = { class: "toggle-click-child" }
const _hoisted_6 = { class: "d-flex flex-row mt-3 toggle-click-parent" }
const _hoisted_7 = { class: "toggle-dropdown toggle-click-child" }
const _hoisted_8 = { class: "toggle-dropdown toggle-click-child" }
const _hoisted_9 = { class: "d-flex flex-row mt-3 toggle-click-parent" }
const _hoisted_10 = { class: "toggle-click-child" }

import AlarmModal from '@/components/modal/AlarmModal.vue'
import DateTimeFilterBar from '../components/filters/datetime/DateTimeFilterBar.vue'
import DropdownToggleTemplate from '../components/filters/dropdown/DropdownToggleTemplate.vue'
import DropDownAlarms from '../components/filters/dropdown/DropDownAlarms.vue'
import MainMap from '@/components/maps/MainMap.vue'
import { Alarm, MapCableDataPoint, CableVessel, HomeClient } from '@/server/MakeSenseApp-backend'
import { computed, onMounted, ref, watch } from 'vue'
import { Modal } from 'bootstrap'
import { useProjectStore } from '@/stores/ProjectStore'
import { useDateTimeStore } from '@/stores/DateTimeFilterStore'
import { watchDebounced } from '@vueuse/core'
import { usePopupStore } from '@/stores/PopupStore'
import { useFilterStore } from '@/stores/HomeFilterStore'

import { requiredInject } from '@/utilities/requiredInject'
import MsSearch from '@/components/general/input/MsSearch.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const client = requiredInject<HomeClient>('HomeClient')

const sensorReadings = ref<MapCableDataPoint[]>([])
const center = ref<number[]>([0, 0])
const alarms = ref<Alarm[]>([])
const alarmCount = ref<number>(0)
const cableLength = ref<number>(0)
const vessels = ref<CableVessel[]>([])

const isLoading = ref<boolean>(false)

let projectStore = useProjectStore()
let dateTimeStore = useDateTimeStore()
let popupStore = usePopupStore()
let filterStore = useFilterStore()

var selectedAlarmId = ref<string>('0')

const searchValue = ref('')

const filteredVessels = computed(() => {
  const search = searchValue.value.toLowerCase().trim()
  return vessels.value.filter(
    (vessel) =>
      vessel.vesselName?.toLowerCase().includes(search) ||
      vessel.mmsi?.toString()?.toLowerCase().includes(search)
  )
})

const latestRequestId = ref(0)

function openModal(selectedId?: string) {
  var element = document.getElementById('alarmModal')

  if (element && selectedId !== undefined) {
    selectedAlarmId.value = selectedId
    var modal = new Modal(element)
    modal.show()
  }
}

async function reloadProjectData(projectId: string, dateTime: Date | null, recenter: boolean) {
  popupStore.closePopup()

  if (projectStore.selectedProject?.dtsHomePageDisabled && filterStore.isDTSActive) {
    filterStore.setDTS()
  }
  if (projectStore.selectedProject?.dasHomePageDisabled && filterStore.isDASActive) {
    filterStore.setDAS()
  }
  if (projectStore.selectedProject?.doBHomePageDisabled && filterStore.isDoBActive) {
    filterStore.setDoB()
  }
  if (projectStore.selectedProject?.vesselsHomePageDisabled && filterStore.isVesselActive) {
    filterStore.setVessel()
  }

  const requestId = ++latestRequestId.value
  isLoading.value = true

  try {
    console.log('Fetching using datetime ' + dateTime)
    const data = await client.getCableOverview(projectId, dateTime)

    // Apply the result only if it's the latest request
    if (requestId === latestRequestId.value) {
      alarms.value = data?.alarms ?? []
      vessels.value = data?.vessels ?? []
      alarmCount.value = data?.alarmCount ?? 0

      sensorReadings.value = data?.cable ?? []
      cableLength.value = data?.cableLength ?? 0

      if (recenter) {
        center.value = [data?.midPoint?.easting ?? 0, data.midPoint?.northing ?? 0]
      }
    }

    dateTimeStore.update()
  } finally {
    // Set loading to false only if this request was the latest
    if (requestId === latestRequestId.value) {
      isLoading.value = false
    }
  }
}

function search(value: string) {
  searchValue.value = value
}

onMounted(() => {
  watch(
    () => projectStore.projectId,
    () => {
      reloadProjectData(projectStore.projectId, dateTimeStore.dateTime, true)
    }
  )

  watchDebounced(
    () => dateTimeStore.dateTime,
    () => {
      reloadProjectData(projectStore.projectId, dateTimeStore.dateTime, false)
    },
    { debounce: 300 }
  )

  reloadProjectData(projectStore.projectId, dateTimeStore.dateTime, true)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AlarmModal, {
      alarms: alarms.value,
      "selected-id": _unref(selectedAlarmId)
    }, null, 8, ["alarms", "selected-id"]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(MainMap, {
        center: center.value,
        "sensor-readings": sensorReadings.value,
        vessels: filteredVessels.value,
        cableLength: cableLength.value
      }, null, 8, ["center", "sensor-readings", "vessels", "cableLength"])
    ]),
    _createElementVNode("main", null, [
      _createVNode(DateTimeFilterBar, { "is-loading": isLoading.value }, {
        search: _withCtx(() => [
          _withDirectives(_createVNode(MsSearch, {
            "place-holder": 'Search for vessel',
            onUpdateText: search
          }, null, 512), [
            [_vShow, _unref(filterStore).isVesselActive]
          ])
        ]),
        _: 1
      }, 8, ["is-loading"]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(DropdownToggleTemplate, {
              title: "DTS",
              disabled: _unref(projectStore).selectedProject?.dtsHomePageDisabled
            }, null, 8, ["disabled"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(DropdownToggleTemplate, {
              title: "DAS",
              disabled: _unref(projectStore).selectedProject?.dasHomePageDisabled
            }, null, 8, ["disabled"])
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(DropdownToggleTemplate, {
              title: "Vessel traffic",
              disabled: _unref(projectStore).selectedProject?.vesselsHomePageDisabled
            }, null, 8, ["disabled"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(DropdownToggleTemplate, {
              title: "DoB",
              disabled: _unref(projectStore).selectedProject?.doBHomePageDisabled
            }, null, 8, ["disabled"])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createVNode(DropDownAlarms, {
              onAlarmClick: openModal,
              alarms: alarms.value,
              disabled: _unref(projectStore).selectedProject?.alarmLogsDisabled,
              "alarm-count": alarmCount.value
            }, null, 8, ["alarms", "disabled", "alarm-count"])
          ])
        ])
      ])
    ])
  ], 64))
}
}

})